module.exports = {
  settings_default_image: "https://eventive.imgix.net/evrt-8eeafa60-a1ed-11ef-a472-ef6d44c311ce-2024-11-13T18:31:54.886Z.jpg",
  leaving_soon_ms: 1000 * 60 * 60 * 24
};
